import React, { useEffect, useRef } from "react";
import Sugar from "sugar";
import { useWindowEvent, useDocumentEvent, useAnimationFrame } from "./Hooks";
import pym from "pym.js";

Sugar.extend();

const pymChild = new pym.Child();

function PymFrame({ children }) {

  const frameRef = useRef();

  const updateFrame = () => {
    pymChild.sendHeight();

    window.parent.postMessage(
      {
        sentinel: "amp",
        type: "embed-size",
        height: document.body.scrollHeight
      },
      "*"
    );
  }

  const updateFrameDebounced = updateFrame.debounce(200);

  useEffect(() => {
    pymChild.sendMessage("childLoaded", "ready");

    window.parent.postMessage(
      {
        sentinel: "amp",
        type: "embed-ready"
      },
      "*"
    );

    var m = window.location.search.match(/parentUrl=(https[^&]+)/);
    if (m && m.length === 2) {
      var pu = decodeURIComponent(m[1]);
      var fbt = document.querySelector('meta[property="og:url"]');
      if (fbt && fbt.content) fbt.content = pu;
      var twt = document.querySelector('meta[name="twitter:url"]');
      if (twt && twt.content) twt.content = pu;
      var cn = document.querySelector("link[rel=canonical]");
      if (cn && cn.content) cn.href = pu;
    }
  }, []);

  useDocumentEvent(
    "DOMContentLoaded",
    () => {
      if (navigator.userAgent.indexOf("iPhone") > 0)
        setTimeout(updateFrame, 500);
      else updateFrame();
    },
    []
  );

  useWindowEvent("resize", updateFrameDebounced);

  let lastHeight = 0;
  useAnimationFrame( () => {
    if( lastHeight != frameRef.current.offsetHeight )
      updateFrame();

    lastHeight = frameRef.current.offsetHeight;
  })

  return <div className="pymFrame" ref={frameRef}>{children}</div>;
}

export default PymFrame;
